import './VehiclesFilter.scss';
import { observer } from 'mobx-react';
import * as React from 'react';
import { VehiclesStore } from '@shared/vehicles/VehiclesStore';
import { CheckboxListDropdown } from '@shared/ui-react/CheckboxListDropdown';
import { cs } from '@shared/utils/utils-classname';
import { Telemetry, TelemetryEventType, TelemetrySource } from '@shared/Telemetry';
import { TrucksStore } from '@pages/trucks/store/TrucksStore';

@observer
export class VehiclesFilter extends React.Component<{
    store: VehiclesStore | TrucksStore;
}> {
    static defaultProps = {
        canHideAll: true,
    };

    render() {
        const store = this.props.store;
        const hasTypes = store.hasOwnProperty('types') && store.hasOwnProperty('vendors');
        const canHideAll = store.hasOwnProperty('showVehiclesOnMap');

        return (
            <div className={cs('vehicles-filter__wrapper', 'app__common-filters__wrapper')}>
                {canHideAll && (
                    <div>
                        <label style={{ marginBottom: '1em' }} className='checkbox-label'>
                            <input type='checkbox' checked={(store as VehiclesStore).showVehiclesOnMap} onChange={this.toggleShowVehicles} />
                            <span>{kuura.getMessage('js_map.show_vehicles_on_map')}</span>
                        </label>
                    </div>
                )}

                <div className='flex-row filters-row' style={{ alignItems: 'stretch' }}>
                    <div>
                        <span>{__('js_vehicles.active_in_last_n_days')}</span>
                        <select
                            value={store.filterActiveInLastDays > 0 ? store.filterActiveInLastDays : -1}
                            onChange={e => (store.filterActiveInLastDays = e.currentTarget.value === '-1' ? null : parseInt(e.currentTarget.value))}
                        >
                            <option value='-1'>-</option>
                            <option value='1'>{__('js_map.one_day')}</option>
                            <option value='7'>{__('js_map.one_week')}</option>
                            <option value='14'>{__('js_map.two_weeks')}</option>
                            <option value='30'>{__('js_map.one_month')}</option>
                        </select>
                    </div>
                </div>
                {hasTypes && (
                    <div className='flex-row filters-row' style={{ alignItems: 'flex-end' }}>
                        <div>
                            <span>{__('js_vehicles.type')}</span>
                            <CheckboxListDropdown list={(store as VehiclesStore).types} />
                        </div>
                        <div>
                            <span>{__('js_vehicles.vendor')}</span>
                            <CheckboxListDropdown list={(store as VehiclesStore).vendors} />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    toggleShowVehicles = () => {
        if (this.props.store instanceof VehiclesStore) {
            this.props.store.showVehiclesOnMap = !this.props.store.showVehiclesOnMap;
            Telemetry.add(TelemetryEventType.MAP_EQUIPMENT_SHOW_VEHICLES, TelemetrySource.MAP_2D_DESKTOP);
        }
    };
}
